/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.5 12.5c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4Zm0-2c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2ZM19.5 15.5c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Zm-2 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.272 0a3 3 0 0 0-2.1212.8787L.8787 6.1507A3 3 0 0 0 0 8.2722v7.4558c0 .7957.316 1.5587.8787 2.1213l5.272 5.2721A3 3 0 0 0 8.2722 24h7.4558a3 3 0 0 0 2.1213-.8787l5.2721-5.2721A3 3 0 0 0 24 15.7279V8.2721a3 3 0 0 0-.8787-2.1213L17.8492.8787A2.9998 2.9998 0 0 0 15.7279 0H8.2721Zm7.4559 2H8.2721a1 1 0 0 0-.7071.2929l-5.2721 5.272A1 1 0 0 0 2 8.2722v7.4558a1 1 0 0 0 .2929.7071l5.272 5.2721c.1876.1875.442.2929.7072.2929h7.4558c.2652 0 .5196-.1054.7071-.2929l5.2721-5.2721A1.0001 1.0001 0 0 0 22 15.7279V8.2721c0-.2652-.1054-.5196-.2929-.7071L16.435 2.2929A1 1 0 0 0 15.7279 2Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'CellDiagram'
);
